jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
  $("#t4s-nav-ul").on("click",".mega-menu-tabs.has-sublink", function(evt){
    let selected = $(this).data("mm-id");
    $(`#t4s-nav-ul  .mega-menu-tabs`).removeClass("mm-tab-active");
    $(`#t4s-nav-ul  .mega-menu-tabs-section`).removeClass("mm-section-active");
    
    $(this).addClass("mm-tab-active");
    $(`#t4s-nav-ul  .mega-menu-tabs-section[data-mm-section-id="${selected}"]`).addClass("mm-section-active");
  });

  $(".t4s-w-100").on("click",".sl-tab-button", function(evt){
    let selected = $(this).data("tab");
    $(`.t4s-w-100  .sl-tab-button`).removeClass("sl-tab-active");
    $(`.t4s-section-inner[tab-section]`).removeClass("sl-section-active");
    
    $(this).addClass("sl-tab-active");
    $(`.t4s-section-inner[tab-section="${selected}"]`).addClass("sl-section-active");
  });
});